import { useEffect, useState } from 'react';
import { quizMap } from '../services/QuizService';
import { handlerError } from '../utils/errorHandler';

export const useQuizzes = (courseId?: string) => {
  const [quizzes, setQuizzes] = useState<Record<number, string>>({});

  useEffect(() => {
    (async function () {
      if (!courseId) return;
      try {
        const quizzes = await quizMap(courseId);
        setQuizzes(quizzes);
      } catch (e) {
        handlerError('Failed to get quizzes');
      }
    })();
  }, [courseId]);

  return {
    quizzes,
  };
};
